import { useState, useEffect } from "react";

const KEY = "probex_avaliacoes";

export function useAvaliacoes() {
  const [avaliacoes, setAvaliacoes] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(avaliacoes));
  }, [avaliacoes]);

  function salvar(avaliacao) {
    const nova = { ...avaliacao, id: Date.now(), data: new Date().toISOString() };
    setAvaliacoes(prev => [nova, ...prev]);
    return nova;
  }

  function remover(id) {
    setAvaliacoes(prev => prev.filter(a => a.id !== id));
  }

  function limparTodas() {
    setAvaliacoes([]);
  }

  return { avaliacoes, salvar, remover, limparTodas };
}
